__turbopack_context__.v({
  "checkboxes": "O5LWFG_checkboxes",
  "container": "O5LWFG_container",
  "content": "O5LWFG_content",
  "counter": "O5LWFG_counter",
  "description": "O5LWFG_description",
  "form": "O5LWFG_form",
  "mktuLink": "O5LWFG_mktuLink",
  "mktuList": "O5LWFG_mktuList",
  "mktuListContainer": "O5LWFG_mktuListContainer",
  "mktuTitle": "O5LWFG_mktuTitle",
  "popup": "O5LWFG_popup",
  "popupContent": "O5LWFG_popupContent",
  "popupHeader": "O5LWFG_popupHeader",
  "popupTitle": "O5LWFG_popupTitle",
  "price": "O5LWFG_price",
  "result": "O5LWFG_result",
  "row": "O5LWFG_row",
  "sendRequest": "O5LWFG_sendRequest",
  "title": "O5LWFG_title",
});
